export const captureException = {
  initialize (sentry) {
    return (error = {}) => {
      error && error.preventDefault && error.preventDefault()
      console.log('!!! ERROR (captureException) Encountered error:', error)
      console.log(error)

      sentry && sentry.captureException(error)
    }
  }
}
